export default __webpack_public_path__ + "static/media/resume_edit_icon.0e479b50.svg";